module.exports = __webpack_public_path__ + "static/media/logo_firmy.f905c8a4.svg";